export default __webpack_public_path__ + "static/media/4df40bffed41b7e9ab11b2a29c1d46ae1581619299153.3c8ff8fd.webp";